import {Component, Input} from '@angular/core';
import {ToleranceDto} from "../../../models/viewmodels/tolerance-viewer-dto.model";
import {DecimalPipe} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {MatTableModule} from "@angular/material/table";

@Component({
  selector: 'colimo-tolerance-table',
  templateUrl: './tolerance-table.component.html',
  imports: [
    DecimalPipe,
    TranslateModule,
    MatTableModule
  ],
  styleUrl: './tolerance-table.component.scss'
})
export class ToleranceTableComponent {
  @Input() public specialColoring: boolean;
  @Input() public tableTitle: string;
  @Input() public headerColumns: string[];
  @Input() public displayedColumns: string[];
  @Input() public toleranceData: ToleranceDto[];
}
